'use client';
import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState } from 'react';
import { Body } from '../Body/Body.js';
import { useUniqueID } from '../../hooks/useUniqueID.js';
import { IconCheck } from '../Icons/Status/Check.js';

const Input = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    name,
    type = 'text',
    className = '',
    onChange,
    onFocus,
    onBlur,
    label,
    error,
    customCheckMark,
    children,
    icon: Icon,
    after,
    ...rest
  } = _ref;
  const [focused, setFocused] = useState(false);
  let testId = 'input';
  if (name) testId += `-${name}`;
  const handleOnChange = event => {
    if (onChange) onChange(event);
  };
  const handleOnFocus = event => {
    if (onFocus) onFocus(event);
    setFocused(true);
  };
  const handleOnBlur = event => {
    if (onBlur) onBlur(event);
    setFocused(false);
  };
  const ErrorIcon = error?.icon || (() => null);
  const id = useUniqueID();
  const inputProps = {
    id,
    ref,
    name,
    type,
    'data-testid': testId,
    onChange: handleOnChange,
    ...rest
  };
  if (type === 'checkbox' || type === 'radio') {
    const CheckMark = customCheckMark || IconCheck;
    return /*#__PURE__*/React__default.createElement("div", {
      className: `b-input b-input--${type}`
    }, /*#__PURE__*/React__default.createElement("label", {
      className: "b-input__toggle-label",
      htmlFor: id
    }, /*#__PURE__*/React__default.createElement("input", inputProps), /*#__PURE__*/React__default.createElement("span", {
      className: `b-input__toggle b-input__toggle--${[type]} ${error?.active ? 'b-input__toggle-error' : ''}`
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "b-input__checkmark"
    }, type === 'checkbox' && /*#__PURE__*/React__default.createElement(CheckMark, null))), label?.children && /*#__PURE__*/React__default.createElement(Body, _extends({
      variant: "caption-lg",
      type: "span"
    }, label, {
      htmlFor: id
    }))), error?.active && error?.children && /*#__PURE__*/React__default.createElement(Body, _extends({
      variant: "caption-lg",
      className: `b-input__error b-input__error--toggle ${error.absolutePosition ? 'b-input__error--absolute' : ''}`,
      type: "span"
    }, error), /*#__PURE__*/React__default.createElement(ErrorIcon, null), error.children));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "b-input b-input--text"
  }, label?.children && !label?.asPlaceholderVariant && /*#__PURE__*/React__default.createElement(Body, _extends({
    variant: "caption-lg",
    type: "label"
  }, label, {
    htmlFor: id
  })), /*#__PURE__*/React__default.createElement("div", {
    className: `b-input__text-container ${label?.asPlaceholderVariant || inputProps.value && label?.asPlaceholderVariant ? 'b-input__text-container--label' : ''}`
  }, label?.asPlaceholderVariant && /*#__PURE__*/React__default.createElement(Body, _extends({
    className: `b-input__text-placeholder-label ${focused || inputProps.value ? 'b-input__text-placeholder-label--active' : ''}`,
    type: "label"
  }, label, {
    variant: focused || inputProps.value ? label.asPlaceholderVariant : label?.variant || 'caption-lg',
    htmlFor: id
  })), Icon && /*#__PURE__*/React__default.createElement("div", {
    className: "b-input__icon"
  }, /*#__PURE__*/React__default.createElement(Icon, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "b-input__text-wrapper"
  }, /*#__PURE__*/React__default.createElement("input", _extends({}, inputProps, {
    placeholder: !label?.asPlaceholderVariant ? inputProps.placeholder : '',
    className: `${className} b-input__text b-input__text--${type} ${label?.children ? 'b-input__text--full-width' : ''} ${error?.active ? 'b-input__text--errored' : ''}`,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur
  })), children && /*#__PURE__*/React__default.createElement("div", {
    className: "b-input__slot"
  }, children)), after), error?.active && error?.children && /*#__PURE__*/React__default.createElement(Body, _extends({
    variant: "caption-lg",
    className: `b-input__error ${error.absolutePosition ? 'b-input__error--absolute' : ''}`,
    type: "span"
  }, error), /*#__PURE__*/React__default.createElement(ErrorIcon, null), error.children));
});
Input.displayName = 'Input';

export { Input };
